<template>
<div class="app-container">

  <transition name="fade" mode="out-in">
    <PetInfo v-if="showpage == 2" :key="'info'" :info="petinfo" :uid= "Uid" @edit="modifyInfo" @showerrorMsg="showerrorMsg"/>
  </transition>
  
  <transition name="fade" mode="out-in">
    <PetCreate v-if="showpage == 1" :key="'create'" @getinfo="getinfo" :uid= "Uid" :info="petinfo"/>
  </transition>
  
  <transition name="fade" mode="out-in">
    <div v-if="showpage == 5" :key="'empty'" class="empty-state">
      <van-empty 
        :description="$t('messages.tips')"
        image="error"
      />
    </div>
  </transition>

  <transition name="fade">
    <div v-if="showpage == 0" :key="'loading'" class="loading-container">
      <van-loading size="48px" vertical color="#ffffff">{{ $t('messages.loading') }}</van-loading>
    </div>
  </transition>

  </div>
</template>

<script>
import PetCreate from './components/PetCreate.vue'
import PetInfo from './components/PetInfo.vue'
import { doc, getDoc } from "firebase/firestore"; 
import { Loading,Empty,showToast } from 'vant';

import { db,idCheck } from "./main.js";


export default {
  name: 'App',
  components: {
    PetCreate,
    PetInfo,
    [Loading.name]:Loading,
    [Empty.name]:Empty,
    [showToast.name]:showToast,


  },

  setup(){
    
  },
  mounted () {
   
  },
  created(){
    document.title = 'Pet Tag';
    let id = window.location.pathname.replace("/","")
    console.log(id); // 第二步
    if(idCheck(id)){
       this.Uid = id;
      this.getinfo()
    }else{
      this.showpage = 5
    }
    
    

  },
  data(){
    return{
      showpage:0,
      petinfo:undefined,
      Uid:""
    }
  },
  methods:{
   async getinfo(isedit){
        this.showpage = 0;
        
        const docSnap =  await getDoc(doc(db, "petInfo", this.Uid));

        if (docSnap.exists()) {
          //console.log("Document data:", docSnap.data());
          this.petinfo = docSnap.data()
          if(isedit){
            this.showpage = 1;
          }else{
            this.showpage = 2;
          }
          
        } else {
        // docSnap.data() will be undefined in this case
         console.log("No such document!");
         this.showpage = 1;

        }
    },
    modifyInfo(){
      console.log("111");
      this.getinfo(true)
    },
    showerrorMsg(){
      showToast(this.$t('messages.key_error'));
    }
  

  }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
}

.app-container {
  min-height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  padding-top: calc(20px + env(safe-area-inset-top));
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}

.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
}

.empty-state {
  margin-top: 50px;
  padding: 20px;
}

html, body {
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
}

/* Vant 主题定制 */
:root {
  --van-empty-description-color: #ffffff;
  --van-primary-color: #5072ff;
  --van-button-primary-background-color: #5072ff;
  --van-button-primary-border-color: #5072ff;
}

/* 页面过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* 响应式优化 */
@media (max-width: 480px) {
  .app-container {
    padding: 16px;
  }
}

@media (min-width: 768px) {
  .app-container {
    padding: 40px 20px;
  }
}
</style>
